function saveOnServer(urlPhp, fileId, fileToSave) //saves results on the server
{ 
//State URL of php-file on server
var urlServer=urlPhp+"?id="+fileId+"&content="+fileToSave;
//var encodedUrlServer = encodeURI(urlServer);
//alert(urlServer);
//Call this URL
$.ajax({url:urlServer,async:false,success:function(){

    }});
}